import { useDispatch, useSelector } from "react-redux";
import { setProgress, setToast } from "../../../../../redux/slice/system";
import { MainAPI } from "../../../../../axios/api";

import { classNames } from "primereact/utils";
import { Button } from "primereact/button";

export default function ModuleTreatmentReference(props) {
  const { onTabChange } = props;
  const dispatch = useDispatch();
  const redux_form = useSelector((state) => state.form);
  const referData = [
    {
      key: 1,
      title:
        "學童近視100問 (臺北市政府衛生局、臺北市政府教育局 2014)、台北市學童高度近視防治網",
    },
    {
      key: 2,
      title: (
        <span>
          Gifford, K. L., Richdale, K., Kang, P., Aller, T. A., Lam, C. S., Liu,
          Y. M., Michaud, L., Mulder, J., Orr, J. B., Rose, K. A., Saunders, K.
          J., Seidel, D., Tideman, J. W. L., & Sankaridurg, P. (2019). IMI -
          Clinical Management Guidelines Report.
          <em>Investigative ophthalmology & visual science,60</em>(3),
          M184–M203. https://doi.org/10.1167/iovs.18-25977
        </span>
      ),
    },
    {
      key: 3,
      title:
        "Yam, J. C., Zhang, X. J., Zhang, Y., Yip, B. H. K., Tang, F., Wong, E. S., Bui, C. H. T., Kam, K. W., Ng, M. P. H., Ko, S. T., Yip, W. W. K., Young, A. L., Tham, C. C., Chen, L. J., & Pang, C. P. (2023). Effect of Low-Concentration Atropine Eyedrops vs Placebo on Myopia Incidence in Children: The LAMP2 Randomized Clinical Trial.JAMA,329(6), 472–481. https://doi.org/10.1001/jama.2022.24162",
    },
    {
      key: 4,
      title:
        "Lawrenson, J. G., Shah, R., Huntjens, B., Downie, L. E., Virgili, G., Dhakal, R., Verkicharla, P. K., Li, D., Mavi, S., Kernohan, A., Li, T., & Walline, J. J. (2023). Interventions for myopia control in children: a living systematic review and network meta-analysis.The Cochrane database of systematic reviews,2(2), CD014758. https://doi.org/10.1002/14651858.CD014758.pub2",
    },
    {
      key: 5,
      title:
        "Ha, A., Kim, S. J., Shim, S. R., Kim, Y. K., & Jung, J. H. (2022). Efficacy and Safety of 8 Atropine Concentrations for Myopia Control in Children: A Network Meta-Analysis.Ophthalmology,129(3), 322–333. https://doi.org/10.1016/j.ophtha.2021.10.016",
    },
    {
      key: 6,
      title:
        "Gan, J., Li, S. M., Wu, S., Cao, K., Ma, D., He, X., Hua, Z., Kang, M. T., Wei, S., Bai, W., & Wang, N. (2022). Varying Dose of Atropine in Slowing Myopia Progression in Children Over Different Follow-Up Periods by Meta-Analysis.Frontiers in medicine,8, 756398. https://doi.org/10.3389/fmed.2021.756398",
    },
    {
      key: 7,
      title:
        "Bullimore, M. A., & Johnson, L. A. (2020). Overnight orthokeratology. Contact lens & anterior eye : the journal of the British Contact Lens Association,43(4), 322–332. https://doi.org/10.1016/j.clae.2020.03.018",
    },
    {
      key: 8,
      title:
        "Hsiao, C. H., Lin, H. C., Chen, Y. F., Ma, D. H., Yeh, L. K., Tan, H. Y., Huang, S. C., & Lin, K. K. (2005). Infectious keratitis related to overnight orthokeratology. Cornea, 24(7), 783–788. https://doi.org/10.1097/01.ico.0000175412.13612.8a",
    },
    {
      key: 9,
      title:
        "Gong, Q., Janowski, M., Luo, M., Wei, H., Chen, B., Yang, G., & Liu, L. (2017). Efficacy and Adverse Effects of Atropine in Childhood Myopia: A Meta-analysis.JAMA ophthalmology,135(6), 624–630. https://doi.org/10.1001/jamaophthalmol.2017.1091",
    },
    {
      key: 10,
      title:
        "Yam, J. C., Li, F. F., Zhang, X., Tang, S. M., Yip, B. H. K., Kam, K. W., Ko, S. T., Young, A. L., Tham, C. C., Chen, L. J., & Pang, C. P. (2020). Two-Year Clinical Trial of the Low-Concentration Atropine for Myopia Progression (LAMP) Study: Phase 2 Report.Ophthalmology,127(7), 910–919. https://doi.org/10.1016/j.ophtha.2019.12.011",
    },
    {
      key: 11,
      title:
        "Huang, J., Mutti, D. O., Jones-Jordan, L. A., & Walline, J. J. (2019). Bifocal & Atropine in Myopia Study: Baseline Data and Methods. Optometry and vision science : official publication of the American Academy of Optometry,96(5), 335–344. https://doi.org/10.1097/OPX.0000000000001378",
    },
    {
      key: 12,
      title:
        "Chamberlain, P., Peixoto-de-Matos, S. C., Logan, N. S., Ngo, C., Jones, D., & Young, G. (2019, Aug). A 3-year Randomized Clinical Trial of MiSight Lenses for Myopia Control. Optom Vis Sci, 96(8), 556-567. https://doi.org/10.1097/opx.0000000000001410",
    },
    {
      key: 13,
      title:
        "Lam, C. S. Y., Tang, W. C., Tse, D. Y.-y., Lee, R. P. K., Chun, R. K. M., Hasegawa, K., Qi, H., Hatanaka, T., & To, C. H. (2020). Defocus Incorporated Multiple Segments (DIMS) spectacle lenses slow myopia progression: a 2-year randomised clinical trial. British Journal of Ophthalmology, 104(3), 363. https://doi.org/10.1136/bjophthalmol-2018-313739",
    },
    {
      key: 14,
      title:
        "Tang, K., Si, J., Wang, X., Lu, X., & Bi, H. (2023, Sep 1). Orthokeratology for Slowing Myopia Progression in Children: A Systematic Review and Meta-Analysis of Randomized Controlled Trials. Eye Contact Lens, 49(9), 404-410. https://doi.org/10.1097/icl.0000000000001006",
    },
    {
      key: 15,
      title:
        "Wei, X. L., Wu, T., Dang, K. R., Hu, K. K., Lu, X. T., Gong, M., Du, Y. R., Hui, Y. N., Tian, X. M., & Du, H. J. (2023). Efficacy and safety of atropine at different concentrations in prevention of myopia progression in Asian children: a systematic review and Meta-analysis of randomized clinical trials. Int J Ophthalmol, 16(8), 1326-1336. https://doi.org/10.18240/ijo.2023.08.20",
    },
  ];

  const saveData = () => {
    dispatch(setProgress(true));

    const checkColumns = ["d1", "d2"];
    const { formUser, formDetail } = redux_form;
    let jsonData = {
      ...formDetail.step1,
      ...formDetail.step2,
      ...formDetail.step3,
      ...formDetail.step4,
      ...formDetail.step5,
      ...formDetail.step6,
      mainid: formUser.id,
      type: 1,
    };
    checkColumns.forEach((column) => {
      jsonData[column] = jsonData[column].join(",");
    });
    jsonData.a1 = String(jsonData.a1);

    MainAPI.setQuestionnaireData({
      data: jsonData,
    }).then((result) => {
      let { Response, message } = result;

      if (Response === 1) {
        dispatch(
          setToast({
            severity: "success",
            summary: `送出成功`,
            detail: "",
          })
        );
        onTabChange({ index: 7 });
      } else {
        dispatch(
          setToast({
            severity: "error",
            summary: `送出失敗`,
            detail: message ?? "",
          })
        );
      }
      dispatch(setProgress(false));
    });
  };

  return (
    <>
      <div className="text-3xl font-bold mt-2 mb-2">參考文獻</div>
      <ol className="text-xl line-height-3 pl-4 m-0">
        {referData.map((item, index) => (
          <li
            key={item.key}
            className={classNames("word-break", {
              "mt-2": index !== 0,
            })}
          >
            {item.title}
          </li>
        ))}
      </ol>

      <div className="text-center my-3">
        {redux_form.formStep && Number(redux_form.formStep) === 1 ? (
          <>
            <Button
              className="p-button-warning text-white px-3 rotate-icon-x-180"
              type="button"
              label="返回比較"
              icon="fa fa-reply bg-main border-round-md p-1"
              onClick={() => onTabChange({ index: 1 })}
            />
          </>
        ) : (
          <>
            <Button
              className="p-button-warning text-white px-3 rotate-icon-x-180"
              type="button"
              label="上一步：提交"
              icon="fa fa-reply bg-main border-round-md p-1"
              onClick={() => onTabChange({ index: 5 })}
            />
            <Button
              className="p-button-warning text-white ml-3 px-3"
              type="button"
              label="確認送出"
              icon="fa fa-check-square-o p-1"
              onClick={() => saveData()}
            />
          </>
        )}
      </div>
    </>
  );
}
